






































































































































import Vue from 'vue';
import {Actions} from '@/store';
import {SignUpForm} from '@/models/account';

export default Vue.extend({
  name: 'RegisterAccountView',
  data() {
    return {
      loader: {
        isLoading: false,
      },
      accountCreated: false,
      form: {
        email: '',
        password: '',
        confirmPassword: '',
        forename: '',
        surname: '',
      },
    };
  },
  methods: {
    async signUp() {
      const isValid = await this.$validator.validate();

      if (!isValid) {
        return;
      }

      this.loader.isLoading = true;

      const model: SignUpForm = {
        email: this.form.email,
        password: this.form.password,
        confirmPassword: this.form.confirmPassword,
        forename: this.form.forename,
        surname: this.form.surname,
      };

      await this.$store
        .dispatch(Actions.account.signUp, model)
        .then(() => {
          this.accountCreated = true;
        })
        .finally(() => {
          this.loader.isLoading = false;
        });
    },
  },
});
